export default __webpack_public_path__ + "static/media/parkshare-ceo.0e4331de.JPG";